'use client';

// Next
import { useRouter } from 'next/navigation';

// Actions
import $actions from '@src/app/_actions';

// Store
import useStore from '@store';


export default function LogoutButton({ icon, label, className, iconEnd }) {
	const router = useRouter();

	const handleLogout = async () => {
		await $actions.auth.logout();
		router.push('/');
	};

	return (
		<button onClick={handleLogout} className={className}>
			{icon}
			<span>{label}</span>
			{iconEnd || null}
		</button>
	);
}
